// IMPORTANT: The brand name "Team Work" is a proper noun and MUST NEVER be translated.
// Do NOT place BRAND inside translations.
export const BRAND = "Team Work";

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      explore: "Explorer",
      favorites: "Favoris",
      requests: "Demandes",
      profile: "Profil",
      realEstate: "Immobilier",
      auto: "Automobile",
      about: "À propos",
      contact: "Contact",
      admin: "Espace Owner",
    },
    hero: {
      eyebrow: "Immobilier & automobile en RDC",
      title1: "Trouvez le bien ou le véhicule",
      title2: "qui vous correspond.",
      subtitle:
        "Parcelles, maisons, véhicules et locations présentés avec clarté, au même endroit.",
      searchWhat: "Je cherche",
      searchWhere: "Où ?",
      searchBudget: "Budget",
      searchCTA: "Rechercher",
      shortcuts: "Raccourcis",
      selections: "Sélections du moment",
      nearYou: "Autour de vous",
      describeSearch: "Décrire ma recherche",
      describeSub: "Décrivez votre projet en quelques étapes et Team Work vous orientera vers les offres adaptées.",
      viewAll: "Voir toutes les offres",
    },
    portal: {
      sale_terrain: "Vente de parcelles",
      sale_vehicle: "Vente de véhicules",
      rent_vehicle: "Location de véhicules",
      rent_home: "Location de maisons",
    },
    // Offer labels used on listing cards & detail (type d'offre)
    offer: {
      sale: {
        villa: "Vente de villa",
        maison: "Vente de maison",
        appartement: "Vente d'appartement",
        terrain: "Vente de parcelle",
        immeuble: "Vente d'immeuble",
        local: "Vente de local",
        bureau: "Vente de bureau",
        entrepot: "Vente d'entrepôt",
        ferme: "Vente de ferme",
        voiture: "Vente de véhicule",
        suv: "Vente de véhicule",
        camion: "Vente de véhicule",
        moto: "Vente de moto",
        engin: "Vente d'engin",
        _default: "Vente",
      },
      rent: {
        villa: "Location de villa",
        maison: "Location de maison",
        appartement: "Location d'appartement",
        local: "Location de local",
        bureau: "Location de bureau",
        entrepot: "Location d'entrepôt",
        voiture: "Location de véhicule",
        suv: "Location de véhicule",
        camion: "Location de véhicule",
        moto: "Location de moto",
        engin: "Location d'engin",
        _default: "Location",
      },
    },
    sectors: {
      realEstate: "Immobilier",
      auto: "Automobile",
      sale: "Vente",
      rent: "Location",
      any: "Tous",
    },
    listing: {
      featured: "Coup de cœur",
      available: "Disponible",
      sold: "Vendu",
      rented: "Loué",
      reserved: "Réservé",
      new: "Nouveau",
      urgent: "Urgent",
      priceDown: "Baisse de prix",
      negotiation: "En négociation",
      details: "Voir les détails",
      book: "Réserver une visite",
      bookEssai: "Réserver un essai",
      contact: "Contacter Team Work",
      whatsapp: "WhatsApp",
      description: "Description",
      specs: "Caractéristiques",
      documents: "Documents",
      docsAvailable: "Disponible",
      docsNotAvailable: "Non disponible",
      docsToVerify: "À vérifier",
      location: "Localisation",
      price: "Prix",
      similar: "Offres similaires",
      backList: "Retour",
      noDocs: "Aucun document publié pour le moment.",
      noMedia: "Media à ajouter par l'équipe Team Work.",
    },
    filters: {
      search: "Rechercher…",
      purpose: "Objet",
      category: "Catégorie",
      city: "Ville",
      minPrice: "Prix min",
      maxPrice: "Prix max",
      apply: "Appliquer",
      reset: "Réinitialiser",
      count: "annonce(s)",
      list: "Liste",
      map: "Carte",
      mapSoon: "Carte interactive des offres à Kinshasa",
    },
    booking: {
      title: "Réserver une visite",
      subtitle: "Choisissez le créneau. Un bon de visite vous sera émis.",
      name: "Nom complet",
      phone: "Téléphone",
      whatsapp: "WhatsApp",
      email: "Email",
      nationality: "Nationalité",
      city: "Ville",
      country: "Pays",
      date: "Date",
      time: "Heure",
      type: "Type de visite",
      physical: "Physique",
      virtual: "Virtuelle",
      essai: "Essai véhicule",
      zone: "Zone de déplacement",
      notes: "Notes / remarques",
      submit: "Confirmer la réservation",
      cancel: "Annuler",
      success: "Réservation confirmée ! Bon de visite n°",
      error: "Impossible de créer la réservation.",
      fees: "Détail des frais",
      visitFee: "Frais de visite",
      travelFee: "Frais de déplacement",
      taxes: "Taxes",
      discount: "Remise",
      total: "Total estimé",
    },
    request: {
      title: "Décrire ma recherche",
      subtitle: "Décrivez votre projet en quelques étapes et Team Work vous orientera.",
      steps: ["Projet", "Budget", "Localisation", "Critères", "Coordonnées", "Validation"],
      project: "Quel est votre projet ?",
      projectOptions: {
        buy_home: "Acheter une maison / villa",
        buy_land: "Acheter une parcelle",
        rent_home: "Louer un logement",
        buy_vehicle: "Acheter un véhicule",
        rent_vehicle: "Louer un véhicule",
        commercial: "Local commercial / bureau",
      },
      budget: "Quel est votre budget ?",
      budgetMin: "Budget min (USD)",
      budgetMax: "Budget max (USD)",
      city: "Dans quelle ville / zone ?",
      criteria: "Précisez vos critères",
      contactStep: "Vos coordonnées",
      review: "Confirmation",
      back: "Retour",
      next: "Suivant",
      submit: "Envoyer la demande",
      confirmedTitle: "Demande envoyée !",
      confirmedText: "L'équipe Team Work vous répondra dès qu'un conseiller aura étudié votre projet.",
      requestNo: "Numéro",
      viewMine: "Voir mes demandes",
      contactWA: "Contacter sur WhatsApp",
      backHome: "Retour à l'accueil",
      statuses: { envoyee: "Envoyée", enCours: "En cours", terminee: "Traitée" },
    },
    favorites: {
      title: "Vos favoris",
      empty: "Aucun favori pour le moment — enregistrez une annonce pour la retrouver ici.",
      compare: "Comparer",
      clear: "Tout vider",
    },
    profile: {
      title: "Profil & préférences",
      language: "Langue",
      currency: "Devise",
      currencyNote: "Les prix restent affichés dans leur devise d'origine (USD). Conversion à venir.",
      about: "À propos",
      contact: "Nous contacter",
      admin: "Espace Owner",
      preferences: "Préférences",
    },
    trust: {
      kicker: "Team Work",
      title: "Une équipe qui vous accompagne.",
      items: [
        { title: "Des informations claires", desc: "Chaque annonce présente ses caractéristiques, son statut et les médias disponibles." },
        { title: "Un contact direct", desc: "Échangez avec Team Work depuis l'annonce qui vous intéresse." },
        { title: "Des parcours transparents", desc: "Recherche, demande, visite et suivi sont regroupés au même endroit." },
        { title: "Immobilier et automobile", desc: "Deux univers, une seule équipe pour vous accompagner." },
      ],
    },
    footer: {
      tagline: "Ensemble, construisons votre avenir.",
      rights: "Tous droits réservés.",
      navigation: "Navigation",
      portals: "Portails",
      information: "Informations",
      contact: "Contact",
      contactCTA: "Contacter Team Work",
      terms: "Conditions d'utilisation",
      privacy: "Politique de confidentialité",
      legal: "Mentions légales",
    },
    about: {
      title: "Une équipe qui vous accompagne.",
      body: "Team Work regroupe l'immobilier et l'automobile au sein d'une seule équipe, pour orienter chaque client — particulier, entreprise ou investisseur — vers l'offre qui lui correspond.",
      pillars: [
        { title: "Immobilier", desc: "Vente & location de villas, maisons, parcelles, immeubles et locaux." },
        { title: "Automobile", desc: "Voitures, SUV, camions, engins et motos — neufs et occasion." },
        { title: "Services", desc: "Photographie, visites, vérification documentaire et gestion locative." },
      ],
    },
    contact: {
      title: "Parlons de votre projet",
      subtitle: "Écrivez à Team Work depuis cette page.",
      address: "Adresse",
      email: "Email",
      phone: "Téléphone",
      whatsapp: "WhatsApp",
      notConfigured: "Non renseigné",
    },
    admin: {
      login: "Connexion Owner",
      email: "Email",
      password: "Mot de passe",
      signIn: "Se connecter",
      dashboard: "Dashboard",
      leads: "CRM / Prospects",
      visits: "Opérations & Visites",
      invoices: "Facturation",
      listings: "Inventaire",
      settings: "Paramètres",
      logout: "Déconnexion",
      todayVisits: "Visites aujourd'hui",
      tomorrowVisits: "Visites demain",
      totalVisits: "Total visites",
      totalLeads: "Total prospects",
      newLeads: "Nouveaux",
      clients: "Clients",
      inventory: "Inventaire",
      available: "Disponibles",
      sold: "Vendus",
      rented: "Loués",
      revenue: "Revenu encaissé",
      pending: "En attente",
      pipeline: "Pipeline commercial",
      recentVisits: "Visites à venir",
      recentInvoices: "Factures récentes",
      siteContact: "Coordonnées publiques",
      siteContactSub: "Ces coordonnées apparaissent sur la page Contact et le pied de page. Laissez vide pour masquer le champ côté public.",
      save: "Enregistrer",
    },
  },
  en: {
    nav: {
      home: "Home",
      explore: "Explore",
      favorites: "Favorites",
      requests: "Requests",
      profile: "Profile",
      realEstate: "Real Estate",
      auto: "Automotive",
      about: "About",
      contact: "Contact",
      admin: "Owner space",
    },
    hero: {
      eyebrow: "Real estate & automotive in DRC",
      title1: "Find the property or vehicle",
      title2: "that suits you.",
      subtitle:
        "Land, homes, vehicles and rentals presented clearly, all in one place.",
      searchWhat: "I'm looking for",
      searchWhere: "Where?",
      searchBudget: "Budget",
      searchCTA: "Search",
      shortcuts: "Shortcuts",
      selections: "Current selections",
      nearYou: "Near you",
      describeSearch: "Describe my search",
      describeSub: "Describe your project in a few steps and Team Work will guide you to matching offers.",
      viewAll: "View all offers",
    },
    portal: {
      sale_terrain: "Land for sale",
      sale_vehicle: "Vehicles for sale",
      rent_vehicle: "Vehicles for rent",
      rent_home: "Homes for rent",
    },
    offer: {
      sale: {
        villa: "Villa for sale",
        maison: "House for sale",
        appartement: "Apartment for sale",
        terrain: "Land for sale",
        immeuble: "Building for sale",
        local: "Commercial for sale",
        bureau: "Office for sale",
        entrepot: "Warehouse for sale",
        ferme: "Farm for sale",
        voiture: "Vehicle for sale",
        suv: "Vehicle for sale",
        camion: "Vehicle for sale",
        moto: "Motorbike for sale",
        engin: "Machinery for sale",
        _default: "For sale",
      },
      rent: {
        villa: "Villa for rent",
        maison: "House for rent",
        appartement: "Apartment for rent",
        local: "Commercial for rent",
        bureau: "Office for rent",
        entrepot: "Warehouse for rent",
        voiture: "Vehicle for rent",
        suv: "Vehicle for rent",
        camion: "Vehicle for rent",
        moto: "Motorbike for rent",
        engin: "Machinery for rent",
        _default: "For rent",
      },
    },
    sectors: { realEstate: "Real Estate", auto: "Automotive", sale: "For sale", rent: "For rent", any: "All" },
    listing: {
      featured: "Featured",
      available: "Available",
      sold: "Sold",
      rented: "Rented",
      reserved: "Reserved",
      new: "New",
      urgent: "Urgent",
      priceDown: "Price drop",
      negotiation: "Negotiating",
      details: "View details",
      book: "Book a visit",
      bookEssai: "Book a test drive",
      contact: "Contact Team Work",
      whatsapp: "WhatsApp",
      description: "Description",
      specs: "Specifications",
      documents: "Documents",
      docsAvailable: "Available",
      docsNotAvailable: "Not available",
      docsToVerify: "To verify",
      location: "Location",
      price: "Price",
      similar: "Similar offers",
      backList: "Back",
      noDocs: "No documents published yet.",
      noMedia: "Media to be added by the Team Work crew.",
    },
    filters: { search: "Search…", purpose: "Purpose", category: "Category", city: "City", minPrice: "Min price", maxPrice: "Max price", apply: "Apply", reset: "Reset", count: "listing(s)", list: "List", map: "Map", mapSoon: "Interactive map of Kinshasa offers" },
    booking: {
      title: "Book a visit", subtitle: "Pick a slot. A visit ticket will be issued.",
      name: "Full name", phone: "Phone", whatsapp: "WhatsApp", email: "Email",
      nationality: "Nationality", city: "City", country: "Country",
      date: "Date", time: "Time", type: "Visit type",
      physical: "In person", virtual: "Virtual", essai: "Test drive",
      zone: "Travel zone", notes: "Notes / remarks",
      submit: "Confirm booking", cancel: "Cancel",
      success: "Booking confirmed! Ticket #", error: "Booking could not be created.",
      fees: "Fee breakdown", visitFee: "Visit fee", travelFee: "Travel fee",
      taxes: "Taxes", discount: "Discount", total: "Estimated total",
    },
    request: {
      title: "Describe my search",
      subtitle: "Describe your project in a few steps and Team Work will guide you.",
      steps: ["Project", "Budget", "Location", "Criteria", "Details", "Confirm"],
      project: "What is your project?",
      projectOptions: {
        buy_home: "Buy a house / villa",
        buy_land: "Buy land",
        rent_home: "Rent a home",
        buy_vehicle: "Buy a vehicle",
        rent_vehicle: "Rent a vehicle",
        commercial: "Commercial / office space",
      },
      budget: "What's your budget?", budgetMin: "Min budget (USD)", budgetMax: "Max budget (USD)",
      city: "Which city / area?", criteria: "Any specific criteria?",
      contactStep: "Your contact details", review: "Confirmation",
      back: "Back", next: "Next", submit: "Send request",
      confirmedTitle: "Request sent!",
      confirmedText: "The Team Work team will reply as soon as an advisor has reviewed your project.",
      requestNo: "Number", viewMine: "See my requests", contactWA: "Contact on WhatsApp", backHome: "Back to home",
      statuses: { envoyee: "Sent", enCours: "In progress", terminee: "Handled" },
    },
    favorites: {
      title: "Your favorites",
      empty: "No favorites yet — save a listing to find it here later.",
      compare: "Compare", clear: "Clear all",
    },
    profile: {
      title: "Profile & preferences",
      language: "Language", currency: "Currency",
      currencyNote: "Prices remain in their source currency (USD). Conversion coming soon.",
      about: "About", contact: "Contact us", admin: "Owner space", preferences: "Preferences",
    },
    trust: {
      kicker: "Team Work",
      title: "A team that supports you.",
      items: [
        { title: "Clear information", desc: "Each listing shows its specs, status and available media." },
        { title: "Direct contact", desc: "Get in touch with Team Work right from the listing you like." },
        { title: "Transparent journey", desc: "Search, request, visit and follow-up gathered in one place." },
        { title: "Real estate & auto", desc: "Two markets, one team to support you." },
      ],
    },
    footer: {
      tagline: "Together, let's build your future.",
      rights: "All rights reserved.",
      navigation: "Navigation", portals: "Portals", information: "Information", contact: "Contact",
      contactCTA: "Contact Team Work",
      terms: "Terms of use", privacy: "Privacy policy", legal: "Legal notice",
    },
    about: {
      title: "A team that supports you.",
      body: "Team Work brings real estate and automotive under a single roof to guide every client — individuals, businesses and investors — to the offer that suits them.",
      pillars: [
        { title: "Real Estate", desc: "Sale & rental of villas, houses, land, buildings and commercial spaces." },
        { title: "Automotive", desc: "Cars, SUVs, trucks, machinery and bikes — new and used." },
        { title: "Services", desc: "Photography, visits, document verification and rental management." },
      ],
    },
    contact: {
      title: "Let's talk about your project",
      subtitle: "Write to Team Work from this page.",
      address: "Address", email: "Email", phone: "Phone", whatsapp: "WhatsApp",
      notConfigured: "Not provided",
    },
    admin: {
      login: "Owner Login", email: "Email", password: "Password", signIn: "Sign in",
      dashboard: "Dashboard", leads: "CRM / Leads", visits: "Operations & Visits",
      invoices: "Billing", listings: "Inventory", settings: "Settings", logout: "Sign out",
      todayVisits: "Visits today", tomorrowVisits: "Visits tomorrow", totalVisits: "Total visits",
      totalLeads: "Total leads", newLeads: "New", clients: "Clients",
      inventory: "Inventory", available: "Available", sold: "Sold", rented: "Rented",
      revenue: "Revenue collected", pending: "Pending",
      pipeline: "Sales pipeline", recentVisits: "Upcoming visits", recentInvoices: "Recent invoices",
      siteContact: "Public contact details",
      siteContactSub: "These details appear on the Contact page and the footer. Leave empty to hide a channel from the public site.",
      save: "Save",
    },
  },
};

export const STAGE_LABELS = {
  fr: { nouveau: "Nouveau", contacte: "Contacté", rdv: "Rendez-vous", visite: "Visité", offre: "Offre", negociation: "Négociation", paiement: "Paiement", client: "Client", perdu: "Perdu" },
  en: { nouveau: "New", contacte: "Contacted", rdv: "Appointment", visite: "Visited", offre: "Offer", negociation: "Negotiation", paiement: "Payment", client: "Client", perdu: "Lost" },
};

export const STAGES_ORDER = ["nouveau", "contacte", "rdv", "visite", "offre", "negociation", "paiement", "client", "perdu"];
